import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { Named } from '../base/named';

@Metamodel.model({
    name: 'DataFlow',
    display: ['dataflowReference', 'dataflowReferences'],
    referable: true,
})
export class DataFlowReference extends Named {
    public static readonly MODEL: IModel;
}
